import React from 'react';
import { Helmet } from 'react-helmet-async';
import { healthBenefits } from '../mock';

const BenefitsPage = () => {
  return (
    <>
      <Helmet>
        <title>Health Benefits of Tofu | Naru Tofu</title>
        <meta name="description" content="Discover the health benefits of tofu - high quality protein, heart health, bone strength, weight management. Learn why tofu is a superfood." />
        <link rel="canonical" href="https://narutofu.com/benefits" />
      </Helmet>
      <section id="benefits" className="benefits-section section-padding" style={{ background: 'var(--bg-secondary)', minHeight: '100vh' }}>
      <div className="container">
        <h1 className="hero-large" style={{ textAlign: 'center', marginBottom: '24px' }}>
          Health Benefits of Tofu
        </h1>
        <p className="body-large" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px', color: 'var(--text-secondary)' }}>
          Discover why tofu is a superfood for modern living. Rich in protein, low in calories, and packed with essential nutrients.
        </p>
        
        <div className="benefits-grid">
          {healthBenefits.map((benefit, index) => (
            <div key={benefit.title} className="benefit-card">
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>{benefit.title}</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div style={{ marginTop: '80px', textAlign: 'center' }}>
          <h2 className="heading-1" style={{ marginBottom: '24px' }}>Perfect for Every Diet</h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Whether you're vegan, vegetarian, or simply looking to add more plant-based protein to your diet, Naru Tofu is the perfect choice. Our tofu is versatile, delicious, and packed with nutrition.
          </p>
        </div>
      </div>
    </section>
    </>
  );
};

export default BenefitsPage;
